"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createProductsApp_1 = require("./createProductsApp");
const ProductList_juomat_1 = require("./ProductList-juomat");
const BrandList_juomat_1 = require("./BrandList-juomat");
const CategoryList_juomat_1 = require("./CategoryList-juomat");
exports.default = (0, createProductsApp_1.default)({
    ProductListComponent: ProductList_juomat_1.default,
    BrandListComponent: BrandList_juomat_1.default,
    CategoryListComponent: CategoryList_juomat_1.default,
});
